/**
 * This file was auto-generated by Fern from our API Definition.
 */

import * as Truvity from '../../../../../api/index';
import * as core from '../../../../../core';
import * as serializers from '../../../../index';

export const DraftExportRequest: core.serialization.Schema<
    serializers.DraftExportRequest.Raw,
    Truvity.DraftExportRequest
> = core.serialization.object({
    issuer: core.serialization.string(),
    validFrom: core.serialization.property('valid_from', core.serialization.date().optional()),
    validUntil: core.serialization.property('valid_until', core.serialization.date().optional()),
});

export declare namespace DraftExportRequest {
    export interface Raw {
        issuer: string;
        valid_from?: string | null;
        valid_until?: string | null;
    }
}
